"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readConsentsFromCookie = exports.persistConsentsInCookie = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));
/**
 * Persist array consents under in a cookie
 * @param {string} cookieName The name of the cookie
 * @param {string[]} consents Array of consents
 * @param {number} expiryInDays Number of days the cookie is valid for
 * @returns {undefined} Undefined
 */


var persistConsentsInCookie = function persistConsentsInCookie(cookieName, consents, expiryInDays) {
  _jsCookie.default.set(cookieName, JSON.stringify(consents), {
    expires: expiryInDays
  });
};
/**
 * Read consents from a cookie
 * @param {string} cookieName The name of the cookie
 * @returns {string[]} Array of consents
 */


exports.persistConsentsInCookie = persistConsentsInCookie;

var readConsentsFromCookie = function readConsentsFromCookie(cookieName) {
  var cookie = _jsCookie.default.get(cookieName);

  return cookie ? JSON.parse(cookie) : [];
};

exports.readConsentsFromCookie = readConsentsFromCookie;